module.exports = __webpack_public_path__ + "entry-150bfe9b/amazon-photo-57b063dca68be60fd3ea7fc5b6300253.webp";